import lodashMerge from 'lodash/merge';
import { workspaceDefaultProperties } from '../../../workspaces/workspaceDefaultProperties';
export function initWorkspace(preferences, data) {
    return lodashMerge({}, workspaceDefaultProperties, preferences, data);
}
